import React from 'react';
import styled from 'styled-components';
import { reduce, size } from 'lodash';
import { dndTypes } from '../helpers/constants';
import { useDrag } from 'react-dnd';
import { Tile, TileStatusEnum } from './Tile';
import { Orientation } from '../types';
import { SelectedTilesContainer } from '../containers/SelectedTilesContainer';
import { Button } from './Button';

type SelectedTilesProps = {
    onClick?: (e: React.MouseEvent<HTMLDivElement>, id: number) => unknown,
};

const SelectedTilesWrapper = styled.div`
    position: relative;
    z-index: 1;
`;

const Tiles = styled.div`
    position: absolute;
    bottom: 100%;
`;

const HorizontalTiles = styled(Tiles)`
    display: flex;
    justify-content: flex-end;
`;

const Container = styled.div`
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    bottom: 100%;
`;

const VerticalTiles = styled(Tiles)``;

export const SelectedTiles: React.FC<SelectedTilesProps> = ({ onClick }) => {
    const { selectedTiles } = SelectedTilesContainer.useContainer();
    const [rotation, setRotation] = React.useState(0);
    const computedTiles =
        rotation === 0 || rotation === 90 ? selectedTiles : selectedTiles.slice(0).reverse();
    const orientation =
        rotation === 0 || rotation === 180 ? Orientation.HORIZONTAL : Orientation.VERTICAL;
    const [, dragRef] = useDrag({
        item: {
            type: dndTypes.TILE_GROUP,
            tiles: computedTiles,
            id: reduce(selectedTiles, (acc, tile) => acc + tile, 0),
            orientation,
        },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    });
    const TilesContainer = orientation === Orientation.VERTICAL ? VerticalTiles : HorizontalTiles;
    return (
        <SelectedTilesWrapper>
            <Container>
                {!!size(selectedTiles) && (
                    <Button onClick={() => setRotation((rotation) => (rotation + 90) % 360)}>
                        Rotate
                    </Button>
                )}
                <TilesContainer ref={dragRef}>
                    {computedTiles.map((id) => (
                        <Tile
                            variant="hand"
                            key={id}
                            id={id}
                            onClick={(e) => {
                                if (onClick) {
                                    onClick(e, id);
                                }
                            }}
                        />
                    ))}
                </TilesContainer>
            </Container>
        </SelectedTilesWrapper>
    );
};
